import React from "react";
import { SvgSrcIcon } from "@/components/SvgSrcIcon";
import { PageModule } from "@/components/PageModule";

type PdpFeature = {
  feature: string;
  image: string;
};

export interface FeatureBannerProps {
  features: PdpFeature[];
}

export const FeatureBanner = ({ features }: FeatureBannerProps) => {
  return (
    <div className="scroll-shadows bg-primary-50 text-primary-50">
      <PageModule className="px-0 py-2">
        <div className="mx-auto flex items-center space-x-4 px-5 md:space-x-8 md:px-14">
          {features
            .filter((iconMsg) => iconMsg.feature && iconMsg.image)
            .map((iconMsg) => (
              <div
                className="flex items-center justify-center"
                key={iconMsg.feature}
              >
                <SvgSrcIcon height={40} width={40} src={iconMsg.image} />
                <p className="body">{iconMsg.feature}</p>
              </div>
            ))}
        </div>
      </PageModule>
    </div>
  );
};
